export const getPriceForGradePage = (price: number, isSoldOut = false) => {
  if (isSoldOut) return;

  return price;
};
